import React, { useState } from "react";
import FormField from "../../components/steps/FormField";
import { IconButton } from "@mui/joy";
import { Visibility, VisibilityOff } from "@mui/icons-material";

interface PasswordFieldProps {
  name: string;
  label: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<any>) => void;
  onBlur: (e: React.FocusEvent<any>) => void;
  touched?: boolean;
  error?: string;
  autoComplete?: string;
  infoText?: string;
  infoIcon?: string;
}

const PasswordField: React.FC<PasswordFieldProps> = ({
  name,
  label,
  placeholder,
  value,
  onChange,
  onBlur,
  touched,
  error,
  autoComplete,
  infoText,
  infoIcon,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const endDecorator = (
    <IconButton
      variant="plain"
      size="sm"
      onClick={() => setShowPassword((prev) => !prev)}
      sx={{ color: "#555" }}
    >
      {showPassword ? <Visibility /> : <VisibilityOff />}
    </IconButton>
  );

  return (
    <FormField
      name={name}
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      touched={touched}
      error={error}
      type={showPassword ? "text" : "password"}
      autoComplete={autoComplete}
      infoText={infoText}
      infoIcon={infoIcon}
      endDecorator={endDecorator}
    />
  );
};

export default PasswordField;
